// extracted by mini-css-extract-plugin
module.exports = {"name":"Name_name__28ddV"};